import { GlobalState } from '@/redux/store';

export const getArticleLinks = (state: GlobalState) => state.articleLinks.links;

export const getArticleLinksNavigationId = (state: GlobalState) => state.articleLinks.navigationId;
